import type {Wallet} from '@stripe-internal/wallet-connect-wrapper';

export const isInAppBrowser = (
  activeWallet: Wallet | null,
  disabledWalletProviders: string[],
): boolean => {
  if (!activeWallet) {
    return false;
  }

  // Phantom wallet is always considered in-app browser
  if (activeWallet.type === 'Phantom') {
    return true;
  }

  // MetaMask is in-app browser if dynamic redirect is disabled
  if (
    activeWallet.type === 'MetaMask' &&
    disabledWalletProviders.includes('dynamic-metamask-redirect')
  ) {
    return true;
  }

  // Coinbase Wallet is in-app browser if dynamic redirect is disabled
  if (
    activeWallet.type === 'Coinbase Wallet' &&
    disabledWalletProviders.includes('dynamic-coinbase-redirect')
  ) {
    return true;
  }

  return false;
};
